import { __awaiter } from "tslib";
import apis from '@/requests';
export const Options = {
    body: {
        id: [],
        name: ['#ms.required'],
        radius: ['#ms.required', '#ms.number', '#ms.range|min:0'],
        verified: [],
        visibled: [],
        latitude: ['#ms.required', '#ms.number'],
        longitude: ['#ms.required', '#ms.number'],
        introduction: ['#ms.length|max:100']
    },
    refs: {
        metadata: '[farmMetadata]'
    },
    defs: {
        verified: () => false,
        visibled: () => 'none'
    },
    views: {
        image(self) {
            return `farms/${self.id}.jpg`;
        }
    },
    loaders: {
        fetch(self, done, fail, { farmId }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    let data = yield apis.farm.get(farmId);
                    self.$init(data);
                    done(self);
                }
                catch (e) {
                    fail(e);
                }
            });
        },
        create(self, done, fail) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    let result = yield apis.farm.create({
                        name: self.name,
                        radius: Number(self.radius),
                        latitude: Number(self.latitude),
                        longitude: Number(self.longitude)
                    });
                    done(result);
                }
                catch (e) {
                    fail(e);
                }
            });
        },
        update(self, done, fail) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield apis.farm.update(self.id, {
                        visibled: self.visibled,
                        metadata: self.metadata.exports(),
                        introduction: self.introduction
                    });
                    done(self);
                }
                catch (error) {
                    fail(error);
                }
            });
        },
        remove(self, done, fail) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield apis.farm.remove(self.id);
                    done(self);
                }
                catch (error) {
                    fail(error);
                }
            });
        }
    },
    list: {
        loaders: {
            fetch(self, done, fail) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let farms = yield apis.farm.list();
                        self.clear();
                        self.batchWrite(farms.items);
                        done(self);
                    }
                    catch (e) {
                        fail(e);
                    }
                });
            }
        }
    }
};
